<template>
    <div>Dashboard</div>
</template>

<script>
</script>

<style scoped>

</style>